import React, { useCallback } from 'react';
import { GenericBaseModule } from './module/generic-base-module';
import { useSelector } from 'react-redux';
import * as appSelectors from 'app/state/app/app-selectors';
import { paymentMethodType } from 'common/constants';
import { Check } from '../pay-by-check/check';

export function Intellipay(props) {
  const {
    strategyInstance,
    strategies,
    params: { text },
  } = props;
  // Copy-pasta from StripePaymentMethodSwitch
  const activePaymentMethodTab = useSelector(appSelectors.activePaymentMethodTab);

  const onClick = useCallback(
    (url) => {
      window.open(url).focus();

      strategyInstance.executeStrategy(strategies, 'postWindowOpen');
    },
    [strategyInstance, strategies]
  );

  if (activePaymentMethodTab === paymentMethodType.CHECK) {
    return <Check {...props} />;
  }
  return (
    <GenericBaseModule onClick={onClick} {...props}>
      <div>{text}</div>
    </GenericBaseModule>
  );
}
